<template>
  <section class="case-creation" v-loading="loading">
    <div class="case-creation__step case-creation__billing-information">
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-billing-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">Additional Notes</h3>
          </div>
        </div>
        <div class="case-creation__body padding-0">
          <div class="billing-information-tabs-view">
            <el-row :gutter="30">
              <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                <div class="input-value view-cases">
                  <h4 class="name">Additional Notes</h4>
                  <p
                    class="value"
                    v-if="
                      this.getSendOutInformation &&
                      this.getSendOutInformation.physician_notes
                    "
                  >
                    {{ this.getSendOutInformation.physician_notes }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      send_out_id: "",
    };
  },
  mounted() {
    if (this.$route.params.sendout_id) {
      this.send_out_id = this.$route.params.sendout_id;
    }
  },
  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
  },
  methods: {},
};
</script>

<style lang="scss">
.case-creation__billing-information {
  .delete-billing-info {
    margin-right: 20px;
    padding: 5px 0;

    button {
      background: #f24a55;
      min-height: 25px;
      border: none;
      padding: 5px 20px;
    }
  }
  .sent-billing-info {
    margin-right: 40px;
    padding: 5px 0;
    color: blue;
  }
  .case-creation__body {
    &.padding-0 {
      padding: 0 !important;
    }
    .billing-information-tabs-view {
      padding: 20px 20px 0;
    }
  }
}
</style>
